import { SAArtwork } from 'types/Artwork'
import { TransformConstructorSearchResultsParams } from '../../constructorTypes'
import { getAspectRatio, getCategoryFromGroups } from '../../libs/helpers/constructor'

export const transformConstructorSearchResults = ({
  searchRequest,
  searchResults,
  destinationZone,
}: TransformConstructorSearchResultsParams): ReadonlyArray<Partial<SAArtwork>> => {
  const { num_results_per_page: hitsPerPage = 100, page = 1 } = searchRequest || {}

  return searchResults.map(({ data, value, labels }, index) => {
    const {
      artist_first_name,
      artist_last_name,
      artist_id,
      country,
      depth,
      geo_prices,
      height,
      id,
      groups,
      image_url,
      is_ready_to_hang,
      materials,
      mediums,
      orientation,
      styles,
      subject,
      url,
      width,
      artist_profile_url,
      image_aspect_ratio,
      print_image_aspect_ratio,
      print_min_price,
      print_materials,
      print_dimensions,
      print_frames,
      original_availability_status,
      print_availability_status,
      sku,
      created_at,
      curated_status,
    } = data
    return {
      artworkTitle: value,
      imageBaseUrl: image_url,
      country,
      firstName: artist_first_name,
      lastName: artist_last_name,
      artistId: Number(artist_id),
      productUrl: url,
      sku: sku ?? '--', // To avoid GTM error
      orientation,
      subject,
      styles,
      materials,
      mediums,
      artworkId: Number(id),
      positionID: hitsPerPage * (page - 1) + (index + 1),
      width,
      height,
      depth,
      listPrice: geo_prices?.[destinationZone],
      listPrices: geo_prices,
      isReadyToHang: is_ready_to_hang ? 1 : 0,
      profileUrl: artist_profile_url,
      category: getCategoryFromGroups(groups),
      aspectRatio: getAspectRatio({
        isPrintsPage: Boolean(print_min_price),
        aspectRatio: image_aspect_ratio,
        printAspectRatio: print_image_aspect_ratio,
      }),
      originalStatus: original_availability_status,
      printStatus: print_availability_status,
      minPrintPrice: print_min_price,
      hasPrint: Boolean(print_min_price),
      hasOpenEditions: Boolean(print_min_price), // needed for data layer events to check if it is original or print
      printUrl: url.replace('/art/', '/print/'), // need to format to include '/print'
      printMaterials: print_materials,
      printDimensions: print_dimensions,
      printFrames: print_frames,
      uploadedDate: created_at,
      curatedStatus: curated_status,
      isSponsored: Boolean(labels?.is_retail_media),
      slCampaignId: labels?.sl_campaign_id,
      slCampaignOwner: labels?.sl_campaign_owner,
    }
  })
}
